import arrayUtilities from "./arrayUtilities";

const randomStringCharacters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
const randomStringSpecialCharacters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-=[]{}|;:',.<>?/~`";

export default {

    emptyGuid: "00000000-0000-0000-0000-000000000000",

    cleanVrm(vrm) {
        const regex = new RegExp(/[^a-zA-Z0-9]/g);
        
        let result = vrm.replace(regex, "");
        result = result.toUpperCase();

        return result;
    },

    isValidVrm(vrm) {
        const regex = new RegExp(/^[A-Z0-9]*$/);
        return regex.test(vrm)
    },

    isNullOrEmpty(str) {
        return !str || str === null || str === "" || Array.isArray(str) || str.trim() === "";
    },

    anyAreNullOrEmpty(strings) {

        let result = false;
        strings.forEach(str => {
            if (this.isNullOrEmpty(str)) {
                result = true;
            }
        });
        return result;
    },

    isNullOrWhiteSpace(str) {
        return !str || str === null || str.trim().length === 0;
    },

    textSizeClass(amount) {

        if (!isNaN(amount)) {
            if (Math.abs(amount) >= 100000000) {
                return " text-xs";
            }
            if (Math.abs(amount) >= 10000000) {
                return " text-sm";
            }
            if (Math.abs(amount) >= 1000000) {
                return " text-md";
            }
            if (Math.abs(amount) >= 100000) {
                return " text-lg";
            }
        }
        return "";
    },

    toInitials(nameParts) {
        if (nameParts && nameParts !== null && nameParts.length > 0) {
            let result = "";

            for (let i = 0; i < nameParts.length; i++)
            {
                if (!this.isNullOrWhiteSpace(nameParts[i])) {
                    result += nameParts[i].substr(0, 1).toUpperCase();
                }
            }
            
            return result.substr(0, Math.min(2, result.length));
        }

        return "";
    },

    photoFormat(contentType) {
        if (!this.isNullOrWhiteSpace(contentType)) {
            switch (contentType.toLowerCase()) {
                case "image/bmp":
                    return "bmp";
                case "image/gif":
                    return "gif";
                case "image/jpeg":
                    return "jpg";
                case "image/png":
                    return "png";
            }
        }

        return null;
    },
    
    formatDecimal(number, decimalPlaces, currencySymbol, showPositivePrefix) {

        if (!isNaN(number)) {
    
            let isNegative = number < 0;
            let unformatted = "" + Math.abs(number).toFixed(decimalPlaces);
            let commaFormatted = "";
    
            let indexIterator = unformatted.indexOf(".");
            if (indexIterator < 0) {
                indexIterator = unformatted.length;
            }
    
            for (let i = indexIterator - 1; i >= 0; i--) {
                commaFormatted = unformatted.substr(i, 1) + commaFormatted;
                if (i > 0 && commaFormatted.replace(/,/g, "").length % 3 === 0) {
                    commaFormatted = "," + commaFormatted;
                }
            }
    
            if (currencySymbol) {
                commaFormatted = currencySymbol + commaFormatted;
            }
    
            if (isNegative) {
                commaFormatted = "-" + commaFormatted;
            } else if (showPositivePrefix) {
                commaFormatted = "+" + commaFormatted;
            }
    
            return commaFormatted + (unformatted.indexOf(".") > -1 ? unformatted.substring(unformatted.indexOf(".")) : "");
        } else {
            let result = 0;
            return result.toFixed(decimalPlaces);
        }
    },

    formatTimeToTwoDigits(hours, minutes) {
        return `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`
    },

    formatHoursMinutes(numberOfMinutes) {
        if (numberOfMinutes === 1440) {
            return "23:59:59"
        }
        const hours = Math.floor(numberOfMinutes / 60);
        const minutes = numberOfMinutes - (hours * 60);
        return this.formatTimeToTwoDigits(hours, minutes)
    },

    formatMinutesToTwentyFourHourClock(numberOfMinutes) {
        if (numberOfMinutes < 0) {
            numberOfMinutes = 1440 - Math.abs(numberOfMinutes);
        } 

        let hours = Math.floor(numberOfMinutes/60);
        let minutes = numberOfMinutes % 60;
        
        return this.formatTimeToTwoDigits(hours, minutes);
    },

    formatTimeStringToMinutes(timeString) {
        const timeArray = timeString.split(":");
        return timeString === "23:59:59" ? 1440 : (Number((timeArray[0] * 60)) + Number(timeArray[1]))
    },

    isTimeOfDayStringAm(timeString) {
        const timeArray = timeString.split(":");
        const temp = Number(timeArray[0]);
        return (temp >= 0 && temp < 12)
    },

    // Signed minutes either side of midnight: AM/noon is positive, PM is negative. Inverse pair.
    timeStringToMidnightOffset(timeString) {
        const minutes = this.formatTimeStringToMinutes(timeString); // 0..1440
        return minutes <= 720 ? minutes : minutes - 1440;
    },

    midnightOffsetToTimeString(offsetMinutes) {
        return this.formatMinutesToTwentyFourHourClock(offsetMinutes) + ":00";
    },

    lengthValidation(string, upperLimit) {
        return !this.isNullOrEmpty(string) ? string.length <= upperLimit : true;
    },

    isValidBase64(string) {
        if (this.isNullOrEmpty(string)) return true;
        return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$/.test(string);
    },

    fetchPolygonPoints(polygonString) {
        
        const pointsSubstring = polygonString.substring(9, polygonString.indexOf(")"));
        const pointsSplit = pointsSubstring.split(",");
        const pointsArray = pointsSplit.reduce((acc, curr, index, array) => {
            if (index < array.length - 1) {
                const point = curr.trim().split(" ");
                acc.push({
                    x: Number(point[0]),
                    y: Number(point[1])
                })
            }  
            return acc;
        }, [])

        return pointsArray;
    },

    sortPreference(key) {
        return JSON.parse(localStorage.getItem(key)) ?? {sortBy: 0, sortDirection: 0};
    },

    zeroRevenueSitesPreference(key) {
        const item = localStorage.getItem(key);
        return item !== null ? JSON.parse(item) : false;
    },

    newLayoutPreference(key) {
        const item = JSON.parse(localStorage.getItem(key))
        if (item !== null) return item
        const legacyItem = JSON.parse(localStorage.getItem("showNewLayout"))
        return legacyItem !== null ? legacyItem : false
    },

    isValidEmailFormat(emailString) {
        let emailRegex = /\S+@\S+\.\S+/;
        return emailRegex.test(emailString)
    },

    ensurePrecedingZero(num) {
       return num < 10 ? "0" + num : num
    },

    contactDetailsName(contactDetails) {
        if (!this.isNullOrEmpty(contactDetails.firstName) || !this.isNullOrEmpty(contactDetails.lastName)) {
            return `${!this.isNullOrEmpty(contactDetails.firstName) ? contactDetails.firstName + " " : ""}${!this.isNullOrEmpty(contactDetails.lastName) ? contactDetails.lastName : ""}`
        } 
        if (!this.isNullOrEmpty(contactDetails.companyName)) {
            return contactDetails.companyName
        } 
        return ""
    },

    pluralSuffixModifier(quantity, word) {

        if (!this.isNullOrEmpty(String(quantity))) {
            if (quantity > 1 || quantity === 0) {
                if (word.endsWith("s")) {
                    return word
                } else {
                    return `${ word }s`
                }
            }

            if (word.endsWith("s")) {
                return word.slice(0, -1)
            }
        }

        return word
    },

    firstCharacterToUppercase(word) {
        if (this.isNullOrEmpty(word)) {
            return null
        }
        return `${word[0].toUpperCase()}${word.slice(1)}`
    },

    abbreviatedDayOfTheWeek(day) {
        return this.firstCharacterToUppercase(day).slice(0,2)
    },

    formatListAsString(items) {
        if (arrayUtilities.isNullOrEmpty(items)) {
            return "";
        }
        if (items.length === 1) {
            return items[0];
        }
        const allButLast = items.slice(0, -1);
        return `${allButLast.join(", ")} and ${items[items.length - 1]}`;
    },

    insertTextAtCursorPosition(text, inputNodeRef, callback) {
        if (inputNodeRef.current) {
            let textToInsert = ' ' + text + ' ';
            let cursorPosition = inputNodeRef.current.selectionStart;
            let textBeforeCursorPosition = inputNodeRef.current.value.substring(0, cursorPosition);
            let textAfterCursorPosition = inputNodeRef.current.value.substring(cursorPosition);
            const newContent = textBeforeCursorPosition + textToInsert + textAfterCursorPosition;
            if (callback) {
                callback(newContent);
            }
        }
    },

    upperCamelCaseToStartCase (string) {
        return string.replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            .trim()
    },

    generateRandomString(length = 32, includeSpecialCharacters = true) {
        const randomBytes = crypto.getRandomValues(new Uint8Array(length));
        const characterSet = includeSpecialCharacters ? randomStringSpecialCharacters : randomStringCharacters;

        return Array.from(randomBytes, (randomByte) => characterSet[randomByte % characterSet.length]).join("");
    }
};